import React, { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import RLIImmersionPlayer from "../../components/LivingDream/RLIImmersionPlayer";
import { useImmersiveMode } from "../../hooks/useImmersiveMode";

const API_URL = process.env.REACT_APP_BACKEND_URL;
// Days with Michael's recorded take: his voice opens the immersion; other days the guide does.
const VOICE_DAYS = new Set([1, 3, 7, 9, 10, 14, 21]);
const U = (id) => `https://images.unsplash.com/${id}?w=1600&fit=crop`;
const SESSIONS = {
  morning: {
    title: "The Morning Immersion", video: "/api/atelier/journey-video/vista/gardens",
    images: ["photo-1636619297905-54f124aa90b2", "photo-1494783367193-149034c05e8f", "photo-1650394850853-bad61e0f6c75", "photo-1499540633125-484965b60031"].map(U),
    lines: ["I am here.", "I arrive in this moment.", "My breath brings me home.", "I meet this day with presence.", "Nothing to rush. Nothing to prove.", "I notice. I soften. I return.", "Presence is always available to me."],
  },
  evening: {
    title: "The Evening Immersion", video: "/api/atelier/journey-video/vista/lakes",
    images: ["photo-1780357543302-e6f02225ea29", "photo-1630494550902-23a1e6027fc5", "photo-1694552514751-b870caaada29", "photo-1497561813398-8fcc7a37b567"].map(U),
    lines: ["I let the day go.", "I was here today, in many moments.", "My body softens into rest.", "There is nothing left to hold.", "I return to stillness.", "Presence is always available.", "I am here."],
  },
};

// Presence Morning / Evening on the Master Immersion standard, keeping Michael's recorded voice for the day.
export default function PresenceImmersion({ session }) {
  const { dayNumber = "1" } = useParams();
  const day = parseInt(dayNumber, 10);
  const nav = useNavigate();
  const s = SESSIONS[session];
  useImmersiveMode(true);
  const started = useRef(Date.now());
  const opening = useMemo(() => (VOICE_DAYS.has(day)
    ? { audio_url: `/api/audio/voice/presence/pres_d${String(day).padStart(2, "0")}_${session}.m4a`, duration: 120 }
    : null), [day, session]);
  const dream = useMemo(() => ({ vision_board: s.images.map((url) => ({ url })), affirmations: s.lines.map((text) => ({ text })) }), [s]);
  const close = () => {
    const token = localStorage.getItem("reclaim_token");
    if (token && Date.now() - started.current > 120000) {  // counts as done only after real time inside
      fetch(`${API_URL}/api/presence-journey/complete`, {
        method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ day, session }),
      }).catch(() => {});
    }
    nav("/reclaim-presence/program");
  };
  return <RLIImmersionPlayer journey={{ title: s.title, video_url: s.video }} dream={dream} coachArea={`presence_${session}`} openingOverride={opening} onClose={close} />;
}
